import React from "react";
import { ADD_RECEIVER_INFO, ADD_SHIPMENT_DETAILS, optionalCostList, paymentInfoOptions } from "constants/global";
import boat from "../../../../asset/images/boat.svg";
import truck from "../../../../asset/icons/truck.svg";
import Input from "component/form/Input";
import Dropdown from "component/form/dropDown";
import currencyPairCheck from "utilities/currencyPairCheck";
import { PercentageInput } from "pages/flex/Procurement/CreatePurchaseOrder";

const AddPaymentInfo = ({
  totalAmount,
  goToStep,
  selectedCurrency,
  paymentDetails,
  setPaymentDetails,
  isThirdStepValid,
  paymentTerm,
  setPaymentTerm,
  additionalCost,
  setAdditionalCost,
  splitPaymentPercentage,
  setSplitPaymentPercentage
}) => {
  // Add a new shipping leg
  const addPaymentDetails = () => {
    setAdditionalCost([
      ...additionalCost,
      {
        id: Date.now(),
        additionalCost: null,
        feeType: null,
      },
    ]);
  };

  // Update a specific shipping leg's state
  const updateShippingLeg = (id, field, value) => {
    setAdditionalCost(
      additionalCost.map((leg) => (leg.id === id ? { ...leg, [field]: value } : leg))
    );
  };

  // Remove a shipping leg
  const removeShippingLeg = (id) => {
    setAdditionalCost(additionalCost.filter((leg) => leg.id !== id));
  };


  const updatePaymentTermsPercentage = (idx, val) => {
    setSplitPaymentPercentage((prv) => {
      const prev = [...prv];
      prev[idx] = val;
      return prev;
    });
  };

  const isPaymentType = paymentTerm?.startsWith("Split")
    ? splitPaymentPercentage[0] + splitPaymentPercentage[1] === 100
    : paymentTerm?.length;

  return (
    <>
      <form onSubmit={(evt) => evt.preventDefault()} className="">
        <h3 className="text-main-dark font-[450] text-2xl !mb-6">
          Add payment information
        </h3>
        <div>
          <div className="flex flex-col w-full mt-3">
            <p className="text-[14px] leading-[19.6px] font-medium	text-gray-10">
              Base costs
            </p>
            <div className="flex rounded-md gap-x-2 gap-y-1">
              <div className="flex items-center w-1/2 h-[56px] mt-2 gap-2 px-3 py-2 rounded-md bg-gray-30">
                <div className="flex items-center">
                  <span className="mr-2 text-base balance_number text-gray-10">
                    <img src={boat} alt="boat" className="size-6" />
                  </span>

                  <p className="text-main-grey">Clearing fee</p>
                </div>
              </div>
              <div className="w-1/2">
                <Input
                  value={paymentDetails.clearingFee}
                  required
                  type="number"
                  placeholder={`${currencyPairCheck(selectedCurrency?.name)} 100`}
                  name="clearingFee"
                  onChange={(value) => {
                    setPaymentDetails((prev) => ({
                      ...prev,
                      clearingFee: value,
                    }));
                  }}
                />
              </div>
            </div>
            <div className="flex rounded-md gap-x-2">
              <div className="flex items-center w-1/2 h-[56px] mt-2 gap-2 px-3 py-2 rounded-md bg-gray-30">
                <div className="flex items-center">
                  <span className="mr-2 text-base balance_number text-gray-10">
                    <img src={truck} alt="truck" className="size-6" />
                  </span>

                  <p className="text-main-grey">Trucking fee</p>
                </div>
              </div>
              <div className="w-1/2">
                <Input
                  type="number"
                  placeholder={`${currencyPairCheck(selectedCurrency?.name)} 100`}
                  name="truckingFee"
                  required
                  value={paymentDetails?.truckingFee}
                  onChange={(value) => {
                    setPaymentDetails((prev) => ({
                      ...prev,
                      truckingFee: value,
                    }));
                  }}
                />
              </div>
            </div>
          </div>
          <div className="mt-6">
            <p className="text-[14px] leading-[19.6px] font-medium	text-gray-10">
              Additional costs (optional)
            </p>
            {additionalCost.map((item, index) => (
              <div
                key={item.id}
                className={`flex flex-col gap-[8px] w-full mb-3 ${index ? "mt-2" : ""
                  }`}
              >
                <div className="flex items-center justify-end">
                  {index ? (
                    <button
                      onClick={() => {
                        removeShippingLeg(item.id);
                      }}
                      className="!text-secondary"
                      type="button"
                    >
                      - Remove Details
                    </button>
                  ) : null}
                </div>
                <div className="flex rounded-md gap-x-2">
                  <div className="flex items-center w-1/2">
                    <Dropdown
                      value={
                        optionalCostList?.find(
                          (fee) => fee.value === item?.feeType
                        )?.label || ""
                      }
                      name="selectShippingMethod"
                      options={optionalCostList
                        .filter((item) => {
                          const currentList = additionalCost.map(
                            (item) => item.feeType
                          );
                          const data =
                            !currentList.includes(item.value) && item;
                          return data;
                        })
                        .map((option) => ({
                          label: option.label,
                          value: option.value,
                        }))}
                      onChange={(value) => {
                        updateShippingLeg(item.id, "feeType", value);
                      }}
                      labelClassName="!text-[#475467]"
                      placeholder="Select additional cost"
                    />
                  </div>
                  <div className="w-1/2">
                    <Input
                      type="number"
                      placeholder={`${currencyPairCheck(
                        selectedCurrency?.name
                      )} 100`}
                      name="additionalCost"
                      className="!mt-0"
                      disabled={!item?.feeType}
                      value={item?.additionalCost}
                      onChange={(value) => {
                        updateShippingLeg(item.id, "additionalCost", value);
                      }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
          <button onClick={addPaymentDetails} className="!text-secondary">
            + Add another
          </button>

          <div style={{ borderTop: "1px dashed #D7DDEA" }} className="p-2 mt-5 text-right">
            <p>
              <span>Total Shipping costs</span> :{" "}
              {currencyPairCheck(selectedCurrency?.name)}{" "}
              {totalAmount ? totalAmount : 0}
            </p>
          </div>

          <Dropdown
            value={paymentTerm}
            name="paymentTerm"
            options={paymentInfoOptions.map((option) => ({
              label: option.label,
              value: option.value,
            }))}
            onChange={(e) => {
              setPaymentTerm(e);
            }}
            label="Payment term"
            labelClassName="!text-[#475467]"
            placeholder="Payment on delivery"
          />

          {paymentTerm?.startsWith("Split") && (
            <div className="bg-[#F6F8FA] !p-4 flex gap-4 relative">
              <PercentageInput
                percent={splitPaymentPercentage[0]}
                setPercent={(val) => updatePaymentTermsPercentage(0, val)}
                max={100 - (splitPaymentPercentage[1] ?? 0)}
                placeholder={"confirmation"}
              />
              <PercentageInput
                percent={splitPaymentPercentage[1]}
                setPercent={(val) => updatePaymentTermsPercentage(1, val)}
                max={100 - (splitPaymentPercentage[0] ?? 0)}
                placeholder={"completion"}
              />

              {splitPaymentPercentage[0] + splitPaymentPercentage[1] !== 100 && (
                <input
                  className="absolute bottom-0 opacity-0 pointer-events-none left-4"
                  pattern="100"
                  defaultValue={20}
                  title="Payment term must total exactly 100"
                  required
                />
              )}
            </div>
          )}
        </div>
        <div className="flex !gap-9 justify-end !mt-6">
          <button
            onClick={() => {
              goToStep(ADD_SHIPMENT_DETAILS);
            }}
            type="button"
            className="button text-[#1D2939] font-[450] !py-2 !px-6"
          >
            Back
          </button>
          <button
            onClick={(e) => {
              e.preventDefault();
              goToStep(ADD_RECEIVER_INFO);
            }}
            disabled={!(isPaymentType && isThirdStepValid.valid)}
            className={`!py-2 !px-6 text-white rounded-lg font-[450] ${!(isPaymentType && isThirdStepValid.valid)
              ? "!bg-[#D9CDFF]"
              : "!bg-secondary"
              }`}
            type="submit"
          >
            Continue
          </button>
        </div>
      </form>
    </>
  );
};

export default AddPaymentInfo;
